<template>
  <div id="page-tobas-form">
    <div class="vs-row">
      <div class="vs-col w-full">
        <card-page card-title="TOBAs">
          <div :class="['form-wrapper', showForm ? '' : 'empty-wrapper']">
            <vue-form-generator
              class="mt-4 readonly-form facilities crud-additive-form bordered-buttons"
              ref="tobasAdditiveForm"
              :model="value"
              :options="formOptions"
              :schema="schema"
            />
          </div>
        </card-page>
        <div class="flex justify-end add-button-wrapper">
          <vs-button class="mx-4 mb-4" v-if="showForm && showAddButton" @click="goToCreate">
            Add
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardPage from '../../../components/Views/CardPage';
import {selectOptions, datepickerOptions, arrayOptions} from '@/components/form/FormElementOption';
import CanAccessMixin from '@/components/mixins/CanAccessMixin';
import FormModelMixin from '@/components/mixins/FormModelMixin';

export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    CardPage
  },
  mixins: [FormModelMixin, CanAccessMixin],
  data() {
    return {
      model: {
        tobas: []
      },
      componentAccess: {
        canCreate: {
          route: 'company.tobas.create',
          access: false
        }
      },
      schema: {
        groups: [
          {
            styleClasses: 'text-black w-full',
            fields: [
              {
                model: 'tobas',
                ...arrayOptions,
                hideAddButton: true,
                showRemoveButton: false,
                items: {
                  type: 'object',
                  schema: {
                    groups: [
                      {
                        styleClasses: 'w-11/12 content',
                        fields: [
                          {
                            disabled: true,
                            type: 'vueMultiSelect',
                            styleClasses: 'w-1/3',
                            label: 'Type',
                            model: 'TOBAType_FK',
                            values: () => this.tobaTypeOptions,
                            selectOptions
                          },
                          {
                            disabled: true,
                            ...datepickerOptions,
                            styleClasses: 'w-1/3',
                            label: 'Start Date',
                            model: 'StartDate'
                          },
                          {
                            disabled: true,
                            ...datepickerOptions,
                            styleClasses: 'w-1/3 border-right',
                            label: 'Expiry Date',
                            model: 'ExpiryDate'
                          },
                          {
                            visible: model => model && model.Note,
                            disabled: true,
                            type: 'input',
                            inputType: 'text',
                            styleClasses: 'w-full note-field border-right',
                            label: 'Note:',
                            model: 'Note'
                          }
                        ]
                      },
                      {
                        styleClasses: 'w-1/12 crud-buttons flex',
                        fields: [
                          {
                            type: 'awesomeButton',
                            styleClasses: 'awesome-form-button edit',
                            buttonOptions: {
                              route: {
                                name: 'company.tobas.edit',
                                routeParam: 'tobaId'
                              },
                              icon: {
                                prefix: 'fal',
                                iconName: 'pencil'
                              }
                            }
                          },
                          {
                            type: 'awesomeButton',
                            styleClasses: 'awesome-form-button delete',
                            buttonOptions: {
                              icon: {
                                prefix: 'fal',
                                iconName: 'times'
                              }
                            },
                            onClick: async model => {
                              this.$emit('deleteToba', model);
                            }
                          }
                        ]
                      }
                    ]
                  }
                }
              }
            ]
          }
        ]
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true
      },
      tobaTypeOptions: [],
      options: [
        {
          endpoint: () => this.$api.companyToba.getOptions(),
          optionsFieldName: 'tobaTypeOptions',
          nameFieldName: 'Type',
          idFieldName: 'TOBAType_FK',
          modelArrayName: 'tobas'
        }
      ]
    };
  },
  computed: {
    showForm() {
      return this.value.tobas ? true : false;
    },
    showAddButton() {
      return this.value.tobas.length < 3 && this.componentAccess.canCreate.access;
    }
  },
  methods: {
    goToCreate() {
      this.$router.push({ name: 'company.tobas.create' });
    }
  }
};
</script>
